import React from "react";
import Navbar from "../components/Navbar";

export default function EmailValidate() {
  return (
    <>
      <Navbar />
      <div className="min-h-screen flex items-center justify-center bg-green-50 p-6">
        <div className="bg-white shadow-lg rounded-2xl p-8 max-w-lg text-center">
          <h2 className="text-2xl font-bold text-green-700 mb-4">
            ✅ ¡Revisa tu correo!
          </h2>
          <p className="text-gray-700 text-sm">
            Te hemos enviado un enlace para verificar tu cuenta. Por favor, revisa tu bandeja de entrada y haz clic en el enlace para activar tu cuenta.
          </p>
        </div>
      </div>
    </>
  );
}
